function initProblemClientCompanyControls(context) {
  const $context = context ? $(context) : $(document);

  function selectedClientPhone($select) {
    const selectedData = ($select.select2 && $select.data('select2')) ? $select.select2('data')[0] : null;
    if (selectedData && selectedData.phone !== undefined && selectedData.phone !== null) {
      return selectedData.phone;
    }

    const $selectedOption = $select.find('option:selected');
    return $selectedOption.data('customerPhone') || $selectedOption.data('customer-phone') || '';
  }

  function updateCustomerPhone($select, fillInput) {
    const phone = selectedClientPhone($select);
    const $form = $select.closest('form');
    const $reference = $form.find('.js-customer-phone-reference');
    const $referenceValue = $form.find('.js-customer-phone-reference-value');

    $referenceValue.text(phone);
    $reference.toggleClass('d-none', !phone);

    if (fillInput) {
      $form.find('.js-problem-caller-tel').val(phone);
    }
  }

  $context.find('.js-client-company-select').each(function() {
    const $select = $(this);
    const ajaxUrl = $select.data('ajaxUrl') || $select.data('ajax-url');
    const dropdownParentSelector = $select.data('dropdownParent') || $select.data('dropdown-parent');
    const select2Options = {
      width: '100%',
      theme: 'bootstrap',
      placeholder: '選択してください',
      allowClear: true,
      minimumInputLength: 1,
      language: {
        inputTooShort: function() {
          return '1文字以上入力してください。';
        },
        noResults: function() {
          return '見つかりません。';
        },
        searching: function() {
          return '検索中...';
        }
      },
      ajax: {
        url: ajaxUrl,
        dataType: 'json',
        delay: 250,
        data: function(params) {
          return { term: params.term };
        },
        processResults: function(data) {
          return data;
        },
        cache: true
      }
    };

    if (dropdownParentSelector && $(dropdownParentSelector).length) {
      select2Options.dropdownParent = $(dropdownParentSelector);
    }

    if ($select.data('select2')) {
      $select.select2('destroy');
    }

    $select.select2(select2Options);
    updateCustomerPhone($select, false);

    $select
      .off('select2:select.problemClientCompanyPhone select2:clear.problemClientCompanyPhone')
      .on('select2:select.problemClientCompanyPhone', function() {
        updateCustomerPhone($(this), true);
      })
      .on('select2:clear.problemClientCompanyPhone', function() {
        updateCustomerPhone($(this), true);
      });
  });

  $context.find('.js-problem-category-select').each(function() {
    const $select = $(this);
    const dropdownParentSelector = $select.data('dropdownParent') || $select.data('dropdown-parent');
    const select2Options = {
      width: '100%',
      theme: 'bootstrap',
      placeholder: '選択してください',
      allowClear: true,
      language: {
        noResults: function() {
          return '見つかりません。';
        }
      }
    };

    if (dropdownParentSelector && $(dropdownParentSelector).length) {
      select2Options.dropdownParent = $(dropdownParentSelector);
    }

    if ($select.data('select2')) {
      $select.select2('destroy');
    }

    $select.select2(select2Options);
  });

  $context.find('.js-problem-status-select').each(function() {
    const $select = $(this);
    const $form = $select.closest('form');
    const originalStatus = $select.data('originalStatus') || $select.data('original-status');

    function updateStatusFields() {
      const status = $select.val();
      const isNewReopen = status === 'reopen' && originalStatus !== 'reopen';
      const isNewCancel = status === 'cancel' && originalStatus !== 'cancel';
      const $cancelRow = $form.find('.js-problem-cancel-reason-row');

      $form.find('.js-problem-reopen-notice').toggleClass('d-none', !isNewReopen);
      $cancelRow.toggleClass('d-none', status !== 'cancel');
      $cancelRow.find('.js-problem-cancel-reason').prop('disabled', status !== 'cancel');

      let submitLabel = '保存';
      if (isNewReopen) {
        submitLabel = '再開して保存';
      } else if (isNewCancel) {
        submitLabel = 'キャンセルとして保存';
      }
      $form.find('.js-problem-submit-text').text(submitLabel);
    }

    $select
      .off('change.problemClientCompanyStatus')
      .on('change.problemClientCompanyStatus', updateStatusFields);
    updateStatusFields();
  });
}

window.initProblemClientCompanyControls = initProblemClientCompanyControls;

function focusProblemClientCompanyFirstField(context) {
  const $context = context ? $(context) : $(document);
  const $clientCompanySelect = $context.find('#problem_client_company_client_company_id').first();

  if (!$clientCompanySelect.length) {
    return;
  }

  function focusElement($element) {
    if (!$element.length) {
      return false;
    }

    if ($element.hasClass('select2-hidden-accessible') && $element.data('select2')) {
      $element.select2('open');
      const searchInput = $('.select2-container--open .select2-search__field').last()[0];
      if (searchInput) {
        searchInput.focus();
        return true;
      }
      return false;
    }

    const element = $element[0];
    if (element) {
      element.focus();
      return document.activeElement === element;
    }

    return false;
  }

  function firstFocusableField() {
    if (!$clientCompanySelect.is(':disabled')) {
      return $clientCompanySelect;
    }

    return $context.find('input, select, textarea, button').filter(function() {
      const $field = $(this);
      return ($field.is(':visible') || $field.hasClass('select2-hidden-accessible')) &&
        !$field.is(':disabled') &&
        $field.attr('data-skip-enter-focus') !== 'true' &&
        $field.attr('type') !== 'hidden';
    }).first();
  }

  let focused = false;
  [100, 180, 300].forEach(function(delay) {
    setTimeout(function() {
      if (focused) {
        return;
      }

      const $field = firstFocusableField();
      if (!$field.length) {
        return;
      }

      focused = focusElement($field);
    }, delay);
  });
}

window.focusProblemClientCompanyFirstField = focusProblemClientCompanyFirstField;

function scrollProblemResponseModalToForm() {
  const $modal = $('#problem-client-comapny-form');
  const $historyEdit = $('#form-problem-history-edit');
  const $incident = $modal.find('.problem-incident-panel').first();
  const $target = ($historyEdit.length && $incident.length)
    ? $incident
    : $('#form-problem-response, #form-problem-history-edit').first();

  if (!$modal.length || !$target.length) {
    return;
  }

  setTimeout(function() {
    const targetTop = $target.offset().top - $modal.offset().top + $modal.scrollTop();
    $modal.stop(true).animate({ scrollTop: Math.max(targetTop - 16, 0) }, 200);
  }, 100);
}

window.scrollProblemResponseModalToForm = scrollProblemResponseModalToForm;

$(document).ready(function() {
  $('.js-problem-status-filter').each(function() {
    const $select = $(this);
    if ($select.data('select2')) {
      $select.select2('destroy');
    }
    $select.select2({
      width: '100%',
      theme: 'bootstrap'
    });
  });

  function csrfHeaders() {
    return {
      'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
    }
  }

  function setProblemModalMode(isResponseModal) {
    $('#problem-client-comapny-form').toggleClass('problem-response-modal', isResponseModal);
  }

  function lockSubmittingForm($form) {
    if ($form.data('submitting')) {
      return false;
    }

    function submittingText(label) {
      if (label === '保存') {
        return '保存中...';
      }
      if (label === '再開して保存') {
        return '再開中...';
      }
      if (label === 'キャンセルとして保存') {
        return '保存中...';
      }
      return '登録中...';
    }

    $form.data('submitting', true);
    $form.attr('aria-busy', 'true');
    $form.find(':submit, .js-open-response-after-create').each(function() {
      const $button = $(this);
      const $text = $button.find('.submit-plan-text').first();

      $button
        .prop('disabled', true)
        .attr('disabled', 'disabled')
        .attr('aria-disabled', 'true')
        .addClass('is-submitting');
      if ($text.length) {
        const originalText = $text.text();
        $text.data('originalText', originalText);
        $text.text(submittingText(originalText));
      }
    });
    return true;
  }

  function unlockSubmittingForm($form) {
    $form.removeData('submitting');
    $form.removeAttr('aria-busy');
    $form.find(':submit, .js-open-response-after-create').each(function() {
      const $button = $(this);
      const $text = $button.find('.submit-plan-text').first();

      $button
        .prop('disabled', false)
        .removeAttr('disabled')
        .removeAttr('aria-disabled')
        .removeClass('is-submitting');
      if ($text.length && $text.data('originalText')) {
        $text.text($text.data('originalText'));
        $text.removeData('originalText');
      }
    });
  }

  function submitProblemForm($form) {
    if (!lockSubmittingForm($form)) {
      return;
    }

    $.ajax({
      url: $form.attr('action'),
      type: 'POST',
      headers: csrfHeaders(),
      data: $form.serialize(),
      dataType: 'script'
    }).fail(function() {
      unlockSubmittingForm($form);
    });
  }

  initProblemClientCompanyControls(document);

  function problemCreateToday() {
    const now = new Date();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${now.getFullYear()}/${month}/${day}`;
  }

  function problemCreateFieldValue(selector) {
    const $form = $('#form-problem');
    return $.trim($form.find(selector).first().val() || '');
  }

  function problemCreateFormIsDirty() {
    const $form = $('#form-problem');
    if (!$form.length || $form.data('newRecord') !== true) {
      return false;
    }

    if (problemCreateFieldValue('#problem_client_company_client_company_id') ||
        problemCreateFieldValue('#problem_client_company_caller_name') ||
        problemCreateFieldValue('#problem_client_company_caller_tel') ||
        problemCreateFieldValue('#problem_client_company_problem_category_id') ||
        problemCreateFieldValue('#problem_client_company_content')) {
      return true;
    }

    return problemCreateFieldValue('#problem_client_company_effect_date') !== problemCreateToday();
  }

  function showProblemCreateCloseConfirm() {
    $('#problem-create-close-confirm').removeClass('d-none');
    $('#problem-create-close-confirm .js-problem-create-close-cancel').trigger('focus');
  }

  function hideProblemCreateCloseConfirm() {
    $('#problem-create-close-confirm').addClass('d-none');
  }

  document.addEventListener('click', function(event) {
    const dismiss = event.target.closest('#problem-client-comapny-form [data-bs-dismiss="modal"]');
    if (!dismiss || !problemCreateFormIsDirty()) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    showProblemCreateCloseConfirm();
  }, true);

  $(document).on('click', '.js-problem-create-close-cancel', function() {
    hideProblemCreateCloseConfirm();
  });

  $(document).on('click', '.js-problem-create-close-confirm', function() {
    hideProblemCreateCloseConfirm();
    $('#problem-client-comapny-form').modal('hide');
  });

  $(document).on('keydown', function(event) {
    if (event.key !== 'Escape' || $('#problem-create-close-confirm').hasClass('d-none')) {
      return;
    }

    event.preventDefault();
    hideProblemCreateCloseConfirm();
  });

  function problemHistoryPopupTitle($trigger) {
    const no = $trigger && ($trigger.data('problemNo') || $trigger.data('problem-no'));
    return no ? `対応履歴 ${no}` : '対応履歴';
  }

  $('#problem-client-comapny-form').on('hidden.bs.modal', function() {
    const $modal = $(this);
    hideProblemCreateCloseConfirm();
    if (!$modal.data('reloadProblemListOnClose')) {
      return;
    }

    $modal.removeData('reloadProblemListOnClose');
    location.reload();
  });

  $(document).on('click','.btn-add-problem', function(e) {
    e.preventDefault();
    const clientCompanyId = $(this).data('clientCompanyId') || $(this).data('client-company-id');
    const source = $(this).data('problemSource') || $(this).data('problem-source');
    const requestData = {};
    if (clientCompanyId) {
      requestData.client_company_id = clientCompanyId;
    }
    if (source) {
      requestData.source = source;
    }
    setProblemModalMode(false);
    $('#title-form-problem').text("障害登録");
    $.ajax({
      url: `/problem_client_companies/new`,
      method: 'GET',
      data: requestData,
      dataType: 'script'
    })
  })

  $(document).on('click', '.btn-edit-problem', function() {
    setProblemModalMode(false);
    $('#title-form-problem').text("完了登録");
    $.ajax({
      url: `/problem_client_companies/${$(this).data('id')}/edit`,
      method: 'GET',
      dataType: 'script'
    })
  })

  $(document).on('click', '.btn-edit-problem-history', function() {
    setProblemModalMode(true);
    $('#title-form-problem').text(problemHistoryPopupTitle($(this)));
    $.ajax({
      url: $(this).data('url'),
      method: 'GET',
      dataType: 'script'
    })
  })

  $(document).on('click', '.btn-add-problem-response', function() {
    const origin = $(this).data('origin');
    const requestData = {};
    if (origin) {
      requestData.origin = origin;
    }
    setProblemModalMode(true);
    $('#title-form-problem').text(problemHistoryPopupTitle($(this)));
    $.ajax({
      url: `/problem_client_companies/${$(this).data('id')}/problem_client_company_responses/new`,
      method: 'GET',
      data: requestData,
      dataType: 'script'
    })
  })

  $(document).on('click', '.btn-edit-problem-response', function() {
    setProblemModalMode(true);
    $('#title-form-problem').text(problemHistoryPopupTitle($(this)));
    $.ajax({
      url: $(this).data('url'),
      method: 'GET',
      dataType: 'script'
    })
  })

  $(document).on('click', '.btn-delete-problem-response', function() {
    if (!window.confirm('削除しますか？')) {
      return;
    }

    $('#title-form-problem').text(problemHistoryPopupTitle($(this)));
    setProblemModalMode(true);
    $.ajax({
      url: $(this).data('url'),
      method: 'DELETE',
      headers: csrfHeaders(),
      dataType: 'script'
    })
  })

  $(document).on('click', '.btn-cancel-problem-response-form', function() {
    const origin = $(this).data('origin');
    const requestData = {};
    if (origin) {
      requestData.origin = origin;
    }
    setProblemModalMode(true);
    $('#title-form-problem').text(problemHistoryPopupTitle($(this)));
    $.ajax({
      url: `/problem_client_companies/${$(this).data('id')}/problem_client_company_responses`,
      method: 'GET',
      data: requestData,
      dataType: 'script'
    })
  })

  $(document).on('click', '.btn-view-problem-responses', function() {
    const source = $(this).data('problemSource') || $(this).data('problem-source');
    const requestData = {};
    if (source) {
      requestData.source = source;
    }
    setProblemModalMode(true);
    $('#title-form-problem').text(problemHistoryPopupTitle($(this)));
    $.ajax({
      url: `/problem_client_companies/${$(this).data('id')}/problem_client_company_responses`,
      method: 'GET',
      data: requestData,
      dataType: 'script'
    })
  })

  $(document).on('click', '.js-open-response-after-create', function(e) {
    e.preventDefault();
    const $form = $(this).closest('form');
    if ($form.data('submitting')) {
      return;
    }

    $form.find('#open-response-form-flag').val('1');
    submitProblemForm($form);
  });

  $(document).on('click', '#form-problem :submit, #form-problem-status :submit, #form-problem-response :submit, #form-problem-history-edit :submit', function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    const $form = $(this).closest('form');
    $form.find('#open-response-form-flag').val('0');
    submitProblemForm($form);
  });

  $(document).on('submit', '#form-problem, #form-problem-status, #form-problem-response, #form-problem-history-edit', function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    const $form = $(this);
    $form.find('#open-response-form-flag').val('0');
    submitProblemForm($form);
  })
})
